import { render, staticRenderFns } from "./SenderCats.vue?vue&type=template&id=5ad4c8d6&"
import script from "./SenderCats.vue?vue&type=script&lang=js&"
export * from "./SenderCats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports